import { graphql } from '~/__gql__';

export const mutationCustomFieldsUpsell = graphql(/* GraphQL */ `
  mutation RequestCustomFieldsUpsell {
    requestCustomFieldsUpsell
  }
`);
